import { render, staticRenderFns } from "./BookmarkPage.vue?vue&type=template&id=b300b840&"
import script from "./BookmarkPage.vue?vue&type=script&lang=js&"
export * from "./BookmarkPage.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports